import VStack from "components/atoms/stack/VStack";
import React from "react";

const WebSplitView = ({ leftItems, rightItems }) => {
	
	return (
		<VStack>
			{ leftItems }

			{ rightItems }
		</VStack>
	)
};

export default WebSplitView;
